import { render, staticRenderFns } from "./BlackJetRouteInfo.vue?vue&type=template&id=5b07918a&"
import script from "./BlackJetRouteInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BlackJetRouteInfo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BlackJetRouteInfo.vue?vue&type=style&index=0&id=5b07918a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports